import axios from "axios";

const api = axios.create({
  baseURL: "https://api.igcprintingpress.com",
  withCredentials: true,
});

export default api;